import { Sprite } from 'pixi.js';
import { EVENT, IMAGES, MainSignals } from '../../../../settings/constants';
import { SCENE_3 } from '../../../../settings/positions';
import SceneBase from '../base/SceneBase';
import WindowCharacter from './WindowCharacter';

export default class Scene3 extends SceneBase {
  chars: WindowCharacter[] = [];

  constructor(signals: MainSignals) {
    super(signals, SCENE_3, 3, 3);

    // parts
    const bg = Sprite.from(IMAGES.BG_3);
    bg.anchor.set(0.5);
    this.addChild(bg);

    this.setCharacters();

    const overlay = Sprite.from(IMAGES.OVERLAY_3);
    overlay.anchor.set(0.5);
    this.addChild(overlay);

    // listeners
    signals.stateCall.add(this.stateCall, this);
  }

  stateCall(event: string): void {
    if (event === EVENT.STATE.SPEECH_DONE) {
      setTimeout(() => {
        this.playAnimation();
      }, 1500);
    }
  }

  playAnimation(): void {
    if (this.isActive && this.chars.length > 0) {
      this.chars[Math.floor(Math.random() * this.chars.length)].playAnimation();
    }
  }

  // --------------------------------------------------------------
  // Characters
  // --------------------------------------------------------------

  setCharacters(): void {
    this.addCharacter(new WindowCharacter(this, '3-char-0.png', -850, -360, 200, 400));
    this.addCharacter(new WindowCharacter(this, '3-char-1.png', -570, -360, 230, 400));
    this.addCharacter(new WindowCharacter(this, '3-char-2.png', -200, -360, 200, 400));
    this.addCharacter(new WindowCharacter(this, '3-char-3.png', 75, -360, 200, 400));
    this.addCharacter(new WindowCharacter(this, '3-char-4.png', 375, -360, 200, 400));
    this.addCharacter(new WindowCharacter(this, '3-char-5.png', 650, -380, 200, 430));
  }

  addCharacter(character: WindowCharacter): void {
    this.addChild(character);
    this.chars.push(character);
  }
}
